<template>
  <!-- 绑定客户分组 -->
  <div class="bindUserGroup">
    <!-- 面包屑导航 -->
    <page-bar
      @back="goBack"
      @refresh="handleRefresh"
      :title="$route.meta.title"
    >
      <template slot="controls">
        <el-link
          icon="el-icon-question"
          type="primary"
          :href="baseUrl + '/UploadFile/Template/客户分组导入客户模板.xls'"
          target="_blank"
          >下载模板</el-link
        >
        <el-button
          type="primary"
          style="margin-left: 10px"
          icon="el-icon-folder-opened"
          @click="dropdownCommand"
          >导入客户</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="getDataList('')"
          >绑定账号</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="selectedList.length == 0"
          @click="bindUser('', 'DEL')"
          >批量删除</el-button
        >
      </template>
    </page-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
          @keyup.enter.native="getTableData(1)"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="userId"
        align="center"
        show-overflow-tooltip
        label="客户编号"
      >
      </el-table-column>
      <el-table-column
        prop="businesscode"
        align="center"
        show-overflow-tooltip
        label="erp编号"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="单位名称"
      >
      </el-table-column>
      <el-table-column
        prop="time"
        align="center"
        show-overflow-tooltip
        label="时间"
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="bindUser(scope.row.id, 'DEL')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 数据选择 -->
    <tableDialog
      v-if="dialogVisible"
      title="数据选择"
      :isMoreSel="true"
      :searchValue="searchData.name"
      :tableData="tableList"
      :tableHead="tableHead"
      :currPage.sync="currPageData"
      :pageSize.sync="pageSizeData"
      :allPage="allPageData"
      :layout="'total, sizes, prev, pager, next, jumper'"
      @search="getDataList"
      @moreSel="selDataOk"
      @rowClick="rowClick"
      @hanCurrChange="hanChangeData"
      @hanSizesChange="hanSizesChange"
      @close="dialogVisible = false"
    ></tableDialog>
    <upload
      ref="upload"
      style="dispay: none"
      @fileChange="uploadGoods"
      :multiple="true"
    ></upload>
  </div>
</template>

<script>
//表单验证
// import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "bindUserGroup",
  data() {
    return {
      id: "",
      /**表格数据 */
      tableData: [],
      searchForm: {
        name: "",
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      selectedList: [],
      // 数据选择
      dialogVisible: false,
      searchData: {
        name: "",
      },
      tableList: [],
      tableHead: {},
      currPageData: 1,
      pageSizeData: 10,
      allPageData: 0,
    };
  },
  mounted() {
    if (this.$route.query.prams) {
      let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
      console.log(this.$route.query);
      if (prams) {
        this.id = prams.id;
        this.getTableData();
      }
    }
  },
  methods: {
    updata() {
      if (this.id) {
        this.getTableData();
      }
    },
    dropdownCommand() {
      this.$refs.upload.handleClick();
    },
    // 商品详情图片上传回调
    uploadGoods(file) {
      file = file.slice(0, 200); //最多可选择200张，多余的将会截断
      if (file.length) {
        let fileData = new FormData();
        for (let i = 0; i < file.length; i++) {
          fileData.append("file", file[i]);
          fileData.append("groupId", this.id);
        }
        this.$uploadRequest({
          url: "/Management/MemberAdmin/ToExcelMemberGroup",
          method: "post",
          data: fileData,
        })
          .then((res) => {
            console.log(res);
            if (res.flag == 0) {
              this.$confirm(res.message + "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {});
            } else {
              this.$confirm(res.message + "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {});
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      }
    },
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "ChainGroupList",
        id: this.id,
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_MembersQuery"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "members/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.tableData = [];
          this.allPage = res.recordCount;
          if (res.flag == 0) {
            this.tableData = (res.data || []).map((item) => ({
              id: item.id,
              userId: item.userid.trim(),
              name: item.businessname,
              time: item.lastmodifytime,
              businesscode: item.businesscode,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    // 获取弹出框表格数据
    getDataList(val, isRep) {
      this.searchData.name = isRep ? val : this.searchData.name;
      let data = {
        type: "GetUserInfo",
        status: "2",
        strWhere: this.searchData.name,
        salesMan: "",
        PageIndex: this.currPageData,
        PageSize: this.pageSizeData,
      };
      let proc = "Proc_Admin_MembersQuery"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "members/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.tableList = (res.data || []).map((item) => ({
              id: item.userid.trim(),
              businesscode: item.businesscode,
              name: item.businessname,
            }));
            this.tableHead = {
              id: "用户编号",
              businesscode: "erp编号",
              name: "单位名称",
            };
            this.allPageData = res.recordCount;
            this.dialogVisible = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**当前页改变 */
    hanChangeData(val) {
      this.currPageData = val;
      this.getDataList();
    },
    hanSizesChange(val) {
      this.pageSizeData = val;
      this.getDataList();
    },
    // 选择单条数据
    rowClick(row) {
      this.selDataOk([row]);
    },
    // 选择数据完成，多选
    selDataOk(selectedList) {
      if (selectedList.length == 0) {
        this.$message({
          message: "请选择数据",
          type: "warning",
        });
        return;
      } else {
        let idList = this.tableData.map((item) => item.userId);
        let newList = [];
        for (let i = 0; i < selectedList.length; i++) {
          if (idList.indexOf(selectedList[i].id) == -1) {
            newList.push(selectedList[i]);
          }
        }
        selectedList = newList;
        if (selectedList.length == 0) {
          this.$message({
            message: "选择的数据已在列表中",
            type: "warning",
          });
          return;
        }
      }
      let id = selectedList.map((item) => item.id).join(",");
      this.bindUser(id, "ADD");
    },
    /**点击绑定或删除客户 */
    bindUser(id, status) {
      let statusType = "IncreaseChain";
      let msg = "确定绑定吗?";
      let msgType = "success";
      if (status == "DEL") {
        id = id || this.selectedList.map((item) => item.id).join(",");
        statusType = "DeleteChain";
        msg = "确定删除吗?";
        msgType = "error";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: msgType,
      })
        .then(() => {
          let data = {
            type: statusType,
            list: id,
            id: this.id,
          };
          let proc = "Proc_Admin_MembersQuery"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "coupon/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                // this.dialogVisible = false;
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.bindUserGroup {
  width: 100%;
  height: 100%;
}
</style>
